import type { CreateAccountsSettingsDictionary } from '@/shared/types/dictionaryTypes';
import { useDictionary } from './useDictionary';
import { useAppSettingsStore } from '@/shared/lib';

const useCreateAccountsSettingsDictionary = () => {
  const { getLanguage } = useAppSettingsStore();

  const { data, isLoading, error } =
    useDictionary<CreateAccountsSettingsDictionary>({
      dictionaryName: 'createaccountssettings',
      language: getLanguage(),
    });

  return {
    createAccountsSettingsData: data,
    createAccountsSettingsLoading: isLoading,
    createAccountsSettingsError: error,
  };
};

export { useCreateAccountsSettingsDictionary };
